import { Table, Select, Button, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import useAuth from '../hooks/useAuth.js';
import 'sweetalert2/dist/sweetalert2.css';
import 'antd/dist/antd.min.css';
import { AssignToTagger } from '../utilities/Assignto.js';
import { Client } from '../utilities/Client.js';
import { Project } from '../utilities/Project.js';
import usePageVisibility from '../utilities/usePageVisibility';
import axiosInstance from '../utilities/axiosInstance';

const FilterData = ({ searchValue }) => {
  const { Option } = Select;
  const { auth } = useAuth();
  const [data, setData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);

  // Columns for the table
  const columnsRow = [
    { title: (
        <Tooltip title="Created Date">
          <span>Date</span>
        </Tooltip>
      ), 
      dataIndex: 'createdDate', 
      key: 'createdDate',
      render: (date) => new Date(date).toLocaleDateString() 
    },
    { 
      title: (
      <Tooltip title="Project">
        <span>Project</span>
      </Tooltip>
      ), 
      dataIndex: 'project_name', 
      key: 'project_name' 
    },
    { title: (
      <Tooltip title="Project Domain">
        <span>Domain</span>
      </Tooltip>
      ), 
      dataIndex: 'project_domain', 
      key: 'project_domain' 
    },
    { title: (
      <Tooltip title="Project Status">
        <span>Status</span>
      </Tooltip>
      ),  
      dataIndex: 'project_status', 
      key: 'project_status'
     },
    { title: (
      <Tooltip title="Client">
        <span>Client</span>
      </Tooltip>
      ),  
      dataIndex: 'project_clientname', 
      key: 'project_clientname' 
    },
    { title: (
      <Tooltip title="Modified Date">
        <span>Modified</span>
      </Tooltip>
      ), 
      dataIndex: 'modifiedDate', 
      key: 'modifiedDate',
      render: (date) => new Date(date).toLocaleDateString()  
    }
  ];

  // Fetch all projects and clients
  const getProjectsClients = () => {
    axiosInstance
      .get(`/getProjectsClients`, {
        params: { profile_id: auth.profile_id, profile_role: auth.profile_role }
      })
      .then((response) => {
        const tasks = response.data.map((items, i, arr) => {
          return {
            "createdDate": arr[i].createdDate,
            "modifiedDate": arr[i].modifiedDate,
            "project_clientname": arr[i].project_clientname,
            "project_domain": arr[i].project_domain,
            "project_id": arr[i].project_id,
            "project_name": arr[i].project_name,
            "project_status": (arr[i].project_status === 1) ? "Active" : "In-Active",
          }
        });
        setData(tasks);
        setFinalData(tasks);  // By default, display all data
      })
      .catch((error) => console.error(error));
  };

  // Filter projects based on the selected client
  const handleClientChange = (clientName) => {
    // setSelectedClient(clientName);
    // setSelectedProject(null); // Reset project selection

    // const filteredData = data.filter(item => item.project_clientname === clientName);
    // setFinalData(filteredData); // Display only filtered data

    setSelectedClient(clientName);
    setSelectedProject(null); // Reset project selection

    // Make API call to filter projects based on selected client
    axiosInstance.get(`/getProjectsClients`, {
      params: {
        profile_id: auth.profile_id,
        profile_role: auth.profile_role,
        project_clientname: clientName, // Added where condition
      },
    })
      .then((response) => {
        const filteredData = response.data;
        setData(filteredData); // Update all projects data (for future filtering)
        setFinalData(filteredData); // Display filtered data
      })
      .catch((error) => console.error(error));

  };

  // Filter data based on the selected project
  const handleProjectChange = (projectName) => {
    setSelectedProject(projectName);

    const filteredData = data.filter(item =>
      item.project_clientname === selectedClient && item.project_name === projectName
    );
    setFinalData(filteredData); // Display only filtered data
  };

  // Reset filters and show all data
  const resetFilters = () => {
    setSelectedClient(null);
    setSelectedProject(null);
    // getProjectsClients();
    axiosInstance
      .get(`/getProjectsClients`, {
        params: { profile_id: auth.profile_id, profile_role: auth.profile_role }
      })
      .then((response) => {
        const tasks = response.data;
        setData(tasks);
        setFinalData(tasks);  // By default, display all data
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    getProjectsClients(); // Fetch all data on component mount
  }, []);

  return (
    <div>
      {/* Client and Project Dropdowns */}
      <div className="flex gap-[10px] justify-end">
          <Client
            pname="Select Client"
            selectedClient={selectedClient}
            onChange={handleClientChange}
          />
          <Project
            pname="Select Project"
            selectedClient={selectedClient}
            selectedProject={selectedProject}
            onChange={handleProjectChange}
          />
        <Button className="min-w-[150px] h-[40px] px-6 py-[10px] rounded-[22px] bg-deep-blue text-white text-[15px] font-medium font-['Poppins'] leading-[100%] text-center align-middle transition-transform duration-200 hover:scale-105 hover:shadow-lg" onClick={resetFilters}>Clear Filters</Button>
      </div>

      {/* Data Table */}
      <Table
        className="details-view-table mt-[20px]"
        columns={columnsRow}
        dataSource={finalData}
        pagination={{ pageSize: 6 }}
      />
    </div>
  );
};

export default FilterData;